<template>

    <div>

      <h5 class="">
        {{ getTitleByType() }}
      </h5>

     <b-row class="mt-4">
        <b-col sm="12" md="3">
          <b-form-group label="Tipo">
          <el-select v-model="type"
                     size="sm"
                     class="form-contol"
                     @change="onChangeType"
          >
            <el-option v-for="formato in tabs"
                       :value="formato.value"
                       :label="formato.text"
                       :key="formato.value"
            />
          </el-select>
          </b-form-group>
        </b-col>
        
        <!-- Selector de plantilla para nuevas etiquetas -->
        <b-col sm="12" md="3" v-if="type === 'et-new'">
          <b-form-group label="Plantilla / Formato">
          <el-select v-model="newLabelsConfig.template_id"
                     size="sm"
                     filterable
                     :loading="loadingTemplates"
                     placeholder="Seleccione una plantilla"
                     class="form-contol"
                     popper-class="sga-select-dropdown"
          >
            <el-option v-for="template in newLabelsTemplates"
                       :value="template.id"
                       :label="template.nombre"
                       :key="template.id"
            >
              <div class="sga-option">
                <span class="option-label">{{ template.nombre }}</span>
                <span class="option-meta">{{ template.tipo === 'asignada' ? 'Asignada' : 'Básica' }}</span>
              </div>
            </el-option>
          </el-select>
          </b-form-group>
        </b-col>
        
        <!-- Tipo de documento (solo para etiquetas actuales) -->
        <b-col sm="12" md="3" v-if="type === 'et' || type === 'te'">
          <b-form-group label="Tipo de documento">
          <el-select v-model="selectedDiseno.selectedFormatoEtiqueta"
                     size="sm"
                     :disabled="type !== 'et'"
                     class="form-contol"
          >
            <el-option v-for="formato in formatosEtiquetaEmpresa"
                       :value="formato.value"
                       :label="formato.text"
                       :key="formato.value"
            />
          </el-select>
          </b-form-group>
        </b-col>
        <b-col sm="12" md="3">
          <b-form-group label="Idioma">
          <el-select v-model="idiomaModel"
                     :options="idiomas"
                     :disabled="type === 'te'"
                     size="sm"
                     @change="onIdiomaChange"
          >
            <el-option v-for="idioma in idiomas"
                       :value="idioma.value"
                       :label="idioma.text"
                       :key="idioma.value"
            />
          </el-select>
          </b-form-group>
        </b-col>

            <b-col sm="12" md="3" :disabled="type !== 'et'" v-if="pdfet.tipoEtiquetaTexto == 'verticales'">
              <b-form-group label="Cabecera">
              <el-checkbox v-model="VisualEmpresa.cabecera"
                           label="Cabecera"
                           class="class-border-checkox-only"
              />
              </b-form-group>
            </b-col>
            <b-col sm="12" md="3" v-if="selectedDiseno.qr || type === 'et' || type === 'et-new' || type === 'te'">
              <b-form-group label="QR">
              <el-checkbox v-model="qrModel"
                           label="QR"
                           :disabled="type === 'te'"
                           class="class-border-checkox-only"
                           @change="onQrChange"
              />
              </b-form-group>
            </b-col>
            <b-col sm="12" md="3" v-if="type === 'et' || type === 'te'">
              <b-form-group label="Lote / Cantidad">
              <el-checkbox v-model="VisualEmpresa.loteCantidadCodigo"
                           label="Lote / Cantidad"
                           :disabled="type !== 'et'"
                           class="class-border-checkox-only"
              />
              </b-form-group>
            </b-col>
            <b-col sm="12" md="3" v-if="type === 'et' || type === 'te'">
              <b-form-group label="Fabricante/Fecha FDS">
              <el-checkbox
                  :disabled="type !== 'et'"
                  v-model="VisualEmpresa.fecha_fab"
                  label="Fabricante/Fecha FDS"
                  class="class-border-checkox-only"
              ></el-checkbox>
              </b-form-group>
            </b-col>

        <b-col sm="12" md="3" v-if="type === 'et' || type === 'te'">
          <b-form-group label="Medida">
            <el-select v-model="pdfet.tipoEtiqueta"
                       :disabled="type !== 'et'"
                       @change="getMedidaEtiquetaTexto"
                       filterable
            >
              <el-option v-for="medida in medidas"
                         :value="medida.value"
                         :label="medida.text"
                         :key="medida.value"
              />
            </el-select>
          </b-form-group>
        </b-col>
        <b-col sm="12" md="3" class="form-group">
          <b-form-group label="Ubicación">
          <tree-select
              :disabled="type === 'te'"
              v-model="ubicacionModel"
              id="slq_location_id"
              name="slq_location_id"
              :multiple="false"
              :defaultExpandLevel="Infinity"
              :options="ubicaciones"
              @input="onUbicacionChange"
          />
          </b-form-group>
        </b-col>
        <b-col sm="12" md="3" v-if="esMultiple && (type === 'et' || type === 'te')">
          <b-form-group label="Multiple" >
            <el-checkbox v-model="mostrarMultiples"
                         @change="resetearCantidad"
                         :disabled="type !== 'et'"
                          class="class-border-checkox-only"
                          label="Multiple"
            />
          </b-form-group>
        </b-col>        
        <b-col sm="12" md="3" v-if="type === 'te' || type === 'et'">
          <b-form-group label="Cantidad">
          <el-select  v-model="pdfet.cantidad"
                     :disabled="!esMultiple || !mostrarMultiples ? true : false"
                     @change="getMedidaEtiquetaTexto"
          >
            <el-option v-for="multiple in optMultiples"
                       :value="multiple"
                       :label="multiple"
                       :key="multiple"
            />
          </el-select>
          </b-form-group>
        </b-col>

       <b-col sm="12" md="3" v-if="type === 'et' || type === 'et-new' || type === 'te'">
         <b-form-group label="Disponible en el inventario">
           <el-select clearable 
                      id="in_useAdjuntoDescarga" 
                      v-model="inUseModel"
                      @change="onInUseChange"
           >
             <el-option value="1" label="SI" />
             <el-option value="0" label="NO" />
           </el-select>
         </b-form-group>
       </b-col>

        <!-- Selector de tamaño de hoja para nuevas etiquetas -->
        <b-col sm="12" md="3" v-if="type === 'et-new'">
          <b-form-group label="Tamaño de la Hoja">
          <el-select v-model="newLabelsConfig.paperSizeDownload"
                     size="sm"
                     class="form-contol"
          >
            <el-option v-for="paperSize in paperSizeNames"
                       :value="paperSize"
                       :label="paperSize"
                       :key="paperSize"
            >
              <span style="float: left">{{ paperSize }}</span>
            </el-option>
          </el-select>
          </b-form-group>
        </b-col>
        
        <!-- Campos de tamaño personalizado para nuevas etiquetas -->
        <b-col sm="12" md="3" v-if="type === 'et-new' && isCustomSizePaper">
          <b-form-group label="Ancho (cm)">
          <el-input-number 
            v-model="newLabelsConfig.paperSizeWidth"
            :min="1"
            :max="10000"
            size="small"
            @change="(val) => setNewLabelsConfig({paperSizeWidth: val})"
          />
          </b-form-group>
        </b-col>
        
        <b-col sm="12" md="3" v-if="type === 'et-new' && isCustomSizePaper">
          <b-form-group label="Alto (cm)">
          <el-input-number 
            v-model="newLabelsConfig.paperSizeHeight"
            :min="1"
            :max="10000"
            size="small"
            @change="(val) => setNewLabelsConfig({paperSizeHeight: val})"
          />
          </b-form-group>
        </b-col>
        
       <b-col sm="12" md="3" v-if="type === 'et-new'">
          <b-form-group label="Cantidad por producto">
          <el-input-number 
            v-model="newLabelsConfig.cantidad_por_producto"
            :min="1"
            :max="100"
            size="small"
            @change="(val) => setNewLabelsConfig({cantidad_por_producto: val})"
          />
          </b-form-group>
        </b-col>

        <b-col sm="12" md="9">
          <filterProductsFilledComponent
            :onRemoteMethod="onHandleChangeProducts"
            :onSelected="onHandleSelectedProductFilled"
            :onTrashSelected="onHandleTrashSelectedProduct"
            :itemsSelecteds="selectedProductFilleds"
          />
        </b-col>

      </b-row>
      <b-row>
        <b-col class="text-center">
          <hr>
          <b-button @click="backRoute()"
                    size="sm"
                    variant="secondary"
                    class="float-left"
          >
            <i class="fa fa-reply fa-lg"></i>
            Volver
          </b-button>
          <b-button v-if="validarPermisoComponente('empresa-editar-descarga-masivas')" class="mx-1 btn-sm"
                    :disabled="isGenerateButtonDisabled()"
                    @click="verificarMultiples"
                    variant="primary"
          >
            <i class="fa fa-check"/>
            Generar
          </b-button>
          <b-button class="mx-1 btn-sm"
                    variant="info"
                    @click="mostrarEtiquetasAgendadas()"
          >
            Consultar {{ getConsultButtonText() }}
          </b-button>
          <b-modal hide-footer
                   v-model="modalEtiquetas"
                   size="xl"
                   :title="`${type === 'et' ? 'Etiquetas agendadas' : 'Tarjetas de emergencia agendadas'}`"
          >
            <etiquetasAgendadas :type="type" :etiquetas="etiquetasProcesadas"/>
          </b-modal>
          <b-modal hide-footer
                   v-model="modalEtiquetas"
                   size="xl"
                   title="Etiquetas agendadas"
          >
            <etiquetasAgendadas :tipo_proceso="tipo_proceso" :etiquetas="etiquetasProcesadas"/>
          </b-modal>
          <b-modal hide-footer
                   v-model="modalTe"
                   size="xl"
                   title="Tarjetas de emergencia agendadas"
          >
            <teAgendadas :tipo_proceso="tipo_proceso" :etiquetas="etiquetasProcesadas"/>
          </b-modal>
        </b-col>
      </b-row>

      <ModalProcessBackground :columns="columns"
                              :type="tipo_proceso"
                              :company_id="selectedEmpresa.id"
                              :title="title"
      />
    </div>

</template>
<script>
import {mapState, mapActions, mapMutations} from 'vuex';
import {getAcls} from '../../plugins/acl';
import etiquetasAgendadas from './EtiquetasAgendadas.vue';
import teAgendadas from './TEAgendadas.vue';
import Swal from 'sweetalert2';
import TreeSelect from "@riophae/vue-treeselect";
import ModalProcessBackground from "@/shared/background_processes/ModalProcessBackground";
import filterProductsFilledComponent from '../productos/FilterProductsFilled.vue'
import { validarPermisoComponente } from "@/plugins/acl";

export default {
    name: 'EtiquetasDescarga',
    data: function () {
        return {
            modalEtiquetas: false,
            modalTe: false,
            esMultiple: true,
            optMultiples: [3, 6, 9],
            mostrarMultiples: false,
            medidasHabilitadas: [],
            tabs : [
              {
                value: 'et',
                text: 'Etiquetas',
              },
              {
                value: 'et-new',
                text: 'Etiquetas nuevas',
              },
              {
                value: 'te',
                text: 'Tarjeta de emergencia',
              }
            ],
          type: 'et-new',
          tipo_proceso: 'ETIQUETAS-MASIVO',
          title: '',
          columns: [],
          columnsEt: [
            {
              key: "downloadable",
              label: "Descargable",
              sortable: true,
              thStyle: {width: '130px !important', 'min-width': '130px !important', 'max-width': '130px !important'}
            },
            {
              key: "json.formatoEtiqueta",
              label: "Formato",
              sortable: true,
              thStyle: {width: '90px !important', 'min-width': '90px !important', 'max-width': '90px !important'}
            },
            {
              key: "json.tipoEtiqueta",
              label: "Tipo de etiquetas",
              sortable: true,
            },
            {key: 'json.total', label: 'Total a descargar', sortable: true, tdClass: 'tipoInventario'},
            {
              key: "fecha_solicitud",
              label: "Fecha de solicitud",
              sortable: true,
              thStyle: {width: '160px !important', 'min-width': '160px !important', 'max-width': '160px !important'}
            },
            {
              key: "fecha_generacion",
              label: "Fecha de generación",
              sortable: true,
              tdClass: "fechaGeneracion",
              thStyle: {width: '170px !important', 'min-width': '170px !important', 'max-width': '170px !important'}
            },
            {
              key: "estado_procesamiento",
              label: "Estado de generación",
              sortable: true,
              tdClass: "estadoGeneracion",
              thStyle: {width: '170px !important', 'min-width': '170px !important', 'max-width': '170px !important'}
            },
            {
              key: "errores",
              label: "Errores",
              sortable: true,
              tdClass: "estadoGeneracion",
              thStyle: {width: '170px !important', 'min-width': '170px !important', 'max-width': '170px !important'}
            },
          ],
          columnsTE: [
            {
              key: "downloadable",
              label: "Descargable",
              sortable: true,
              thStyle: {width: '130px !important', 'min-width': '130px !important', 'max-width': '130px !important'}
            },
            {
              key: "fecha_solicitud",
              label: "Fecha de solicitud",
              sortable: true,
              thStyle: {width: '160px !important', 'min-width': '160px !important', 'max-width': '160px !important'}
            },
            {
              key: "fecha_generacion",
              label: "Fecha de generación",
              sortable: true,
              tdClass: "fechaGeneracion",
              thStyle: {width: '170px !important', 'min-width': '170px !important', 'max-width': '170px !important'}
            },
            {
              key: "estado_procesamiento",
              label: "Estado de generación",
              sortable: true,
              tdClass: "estadoGeneracion",
              thStyle: {width: '170px !important', 'min-width': '170px !important', 'max-width': '170px !important'}
            },
            {
              key: "errores",
              label: "Errores",
              sortable: true,
              tdClass: "estadoGeneracion",
              thStyle: {width: '170px !important', 'min-width': '170px !important', 'max-width': '170px !important'}
            },
          ],
          columnsNewEt: [
            {
              key: "downloadable",
              label: "Descargable",
              sortable: true,
              thStyle: {width: '130px !important', 'min-width': '130px !important', 'max-width': '130px !important'}
            },
            {
              key: "json.template_name",
              label: "Plantilla",
              sortable: true,
              thStyle: {width: '90px !important', 'min-width': '90px !important', 'max-width': '90px !important'}
            },
            {
              key: "json.template_type",
              label: "Tipo",
              sortable: true,
              formatter: (value) => {
                return value === 'asignada' ? 'Asignada' : 'Básica';
              }
            },
            {key: 'json.total', label: 'Total a descargar', sortable: true, tdClass: 'tipoInventario'},
            {
              key: "fecha_solicitud",
              label: "Fecha de solicitud",
              sortable: true,
              thStyle: {width: '160px !important', 'min-width': '160px !important', 'max-width': '160px !important'}
            },
            {
              key: "fecha_generacion",
              label: "Fecha de generación",
              sortable: true,
              tdClass: "fechaGeneracion",
              thStyle: {width: '170px !important', 'min-width': '170px !important', 'max-width': '170px !important'}
            },
            {
              key: "estado_procesamiento",
              label: "Estado de generación",
              sortable: true,
              tdClass: "estadoGeneracion",
              thStyle: {width: '170px !important', 'min-width': '170px !important', 'max-width': '170px !important'}
            },
            {
              key: "errores",
              label: "Errores",
              sortable: true,
              tdClass: "estadoGeneracion",
              thStyle: {width: '170px !important', 'min-width': '170px !important', 'max-width': '170px !important'}
            },
            ],
          selectedProductFilleds: [],
          validarPermisoComponente: validarPermisoComponente,
          paperSizeNames: [
            'A3', 'A4', 'A5','Legal', 'Carta', 'Tabloid', 'Otro'
          ],
        };
    },
    components: {
        etiquetasAgendadas,
        TreeSelect,
        teAgendadas,
        ModalProcessBackground,
        filterProductsFilledComponent
    },
    async created() {
        await this.getDiseno({ id: this.$route.params.id })
        this.resetVisualEmpresa();
        var acls = getAcls();
        var rol = acls.roles.toString();
        this.asignaRol(rol);
        this.asignarParametrosEtiqueta({tipoEtiqueta: 'A', tipoEtiquetaTexto: 'verticales'});
        this.resetDataPdfTE();
        this.resetDataMeasures();
        const filterMin = this.medidas.filter(item => item.text.includes("ET Mini"));
        const filterVerticales = this.medidas.filter(item => ((item.tipo === 'verticales') && (!item.text.includes("ET Mini"))));
        const filterResulution = this.medidas.filter(item => item.tipo === 'resolucion');
        const filterHalliburton = this.medidas.filter(item => item.tipo === 'halliburton'); //11
        const filterBacker = this.medidas.filter(item => item.tipo === 'baker'); // 111

        const hasMini = this.selectedDiseno.etiqueta_mini == 1 ? true : false;
        const hasVertical = this.selectedDiseno.etiqueta_vertical == 1 ? true : false;
        const hasResolution = this.selectedDiseno.etiqueta_resolucion == 1 ? true : false;

        let filterEts = [];

        if (hasMini && hasVertical && hasResolution) {
            filterEts = [...filterMin, ...filterVerticales, ...filterResulution];
        } else if (hasMini && hasVertical && !hasResolution) {
            filterEts = [...filterMin, ...filterVerticales];
        } else if (hasMini && !hasVertical && hasResolution) {
            filterEts = [...filterMin, ...filterResulution];
        } else if (!hasMini && hasVertical && hasResolution) {
            filterEts = [...filterVerticales, ...filterResulution];
        } else if (hasMini && !hasVertical && !hasResolution) {
            filterEts = [...filterMin];
        } else if (!hasMini && hasVertical && !hasResolution) {
            filterEts = [...filterVerticales];
        } else if (!hasMini && !hasVertical && hasResolution) {
            filterEts = [...filterResulution];
        }
        if (this.$route.params.id == 11) {
            filterEts = filterEts.concat(filterHalliburton);
        }
        if (this.$route.params.id == 111) {
            filterEts = filterEts.concat(filterBacker);
        }
       this.setLabelsToDownload(filterEts);
      await this.obtenerUbicaciones(this.$route.params.id)
      
      // Cargar plantillas para nuevas etiquetas
      await this.fetchNewLabelsTemplates(this.$route.params.id);
      this.resetNewLabelsConfig();
    },
    methods: {
      ...mapActions("tareas", [ "obtenerUbicaciones"]),
      ...mapActions("background_processes", [ "loadProccessBackground","generateScheduling"]),
      ...mapActions("etiquetas", [ "fetchNewLabelsTemplates", "generateNewLabelsScheduling"]),
        async resetearCantidad(mostrarMultiple) {
            if (!mostrarMultiple) {
                this.asignarParametrosEtiqueta({cantidad: null});
            } else {
                if (this.optMultiples.length) {
                    let cantidad = this.optMultiples[0];
                    this.asignarParametrosEtiqueta({cantidad: cantidad});
                }
            }
        },
      async mostrarEtiquetasAgendadas() {
        if (this.type === 'et') {
          this.title = 'Etiquetas'
          this.tipo_proceso = 'ETIQUETAS-MASIVO';
          this.columns = this.columnsEt;
        } else if (this.type === 'et-new') {
          this.title = 'Etiquetas nuevas'
          this.tipo_proceso = 'NUEVAS-ETIQUETAS-MASIVO';
          this.columns = this.columnsNewEt;
        } else if (this.type === 'te') {
          this.title = 'Tarjetas emergencia'
          this.tipo_proceso = 'TARJETAS-EMERGENCIA-MASIVO';
          this.columns = this.columnsTE;
        }
        await this._loadProccessBackground(this.tipo_proceso);
      },
        getMedidaEtiquetaTexto(e) {
            const self = this;
            this.medidas.filter((tipo) => {
                if (tipo.value === e && this.mostrarMultiples) {
                    if (tipo.multiple.length) {
                        self.esMultiple = true;
                        self.optMultiples = tipo.multiple;
                    } else {
                        self.esMultiple = false;
                        self.optMultiples = [];
                    }

                    let cantidad = this.optMultiples.length ? this.optMultiples[0] : 0;

                    self.asignarParametrosEtiqueta({
                        medidaEtiquetaTexto: tipo.text,
                        tipoEtiquetaTexto: tipo.tipo,
                        cantidad: cantidad
                    });
                }
            });
        },
        async verificarMultiples() {
        let params = null;
        if (this.type === 'et'){
          this.tipo_proceso = 'ETIQUETAS-MASIVO';
          if (this.pdfet.cantidad > 1) {
            await Swal.fire({
              title: '¿Desea generar solo etiquetas en la misma página?',
              text: '',
              icon: 'warning',
              showCancelButton: true,
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#d33',
              confirmButtonText: 'Si',
              cancelButtonText: 'No, generar todas'
            }).then(async (result) => {
              if (result.value) {
                this.asignarParametrosEtiqueta({multiplesPaginasMasivo: false});
              } else {
                this.asignarParametrosEtiqueta({multiplesPaginasMasivo: true});
              }
            });
          }
          params = {
            empresa: this.selectedEmpresa.id,
            idioma: this.VisualEmpresa.idioma,
            version: 6,
            regla: this.VisualEmpresa.regla,
            fabfecha: this.VisualEmpresa.fecha_fab,
            rol: 1,
            tipoproducto: 'producto',
            cabecera: this.VisualEmpresa.cabecera,
            qr: (this.selectedDiseno.qr && this.VisualEmpresa.qr) ? true : false,
            loteCantidadCodigo: this.VisualEmpresa.loteCantidadCodigo,
            formatoEtiqueta: this.selectedDiseno.selectedFormatoEtiqueta,
            slq_location_id: this.VisualEmpresa.slq_location_id,
            tipoEtiqueta: this.pdfet.tipoEtiqueta,
            cantidad : this.pdfet.cantidad,
            multiplesPaginasMasivo: this.pdfet.multiplesPaginasMasivo,
            products: this.selectedProductFilleds.map(x => x.id),
            in_use : this.pdfet.in_use
          }
        } else if (this.type === 'et-new'){
          if (!this.newLabelsConfig.template_id) {
            if (this.$vue.$alertErrorsCallback({ errors: { template_id: ['Debe seleccionar una plantilla antes de generar las etiquetas'] } })) return;
            this.$vue.$alertError('Seleccione una plantilla antes de generar las etiquetas');
            return;
          }
          
          this.tipo_proceso = 'NUEVAS-ETIQUETAS-MASIVO';
          
          const selectedTemplate = this.newLabelsTemplates.find(template => template.id === this.newLabelsConfig.template_id);
          const template_name = selectedTemplate ? selectedTemplate.nombre : 'Template no encontrado';
          const template_type = selectedTemplate ? selectedTemplate.tipo : 'basica';
          
          params = {
            empresa: this.selectedEmpresa.id,
            template_id: this.newLabelsConfig.template_id,
            template_name: template_name,
            template_type: template_type,
            idioma: this.newLabelsConfig.idioma,
            qr: this.newLabelsConfig.qr,
            slq_location_id: this.newLabelsConfig.slq_location_id,
            cantidad_por_producto: this.newLabelsConfig.cantidad_por_producto,
            in_use: this.newLabelsConfig.in_use,
            products: this.selectedProductFilleds.map(x => x.id),
            paper_size: this.newLabelsConfig.paperSizeDownload,
            has_custom_paper_size: this.newLabelsConfig.paperSizeDownload === 'Otro' ? true : false,
            paper_size_width: this.newLabelsConfig.paperSizeWidth,
            paper_size_height: this.newLabelsConfig.paperSizeHeight
          }
        } else if (this.type === 'te'){
          this.tipo_proceso = 'TARJETAS-EMERGENCIA-MASIVO';
          params = {
            empresa: this.selectedEmpresa.id,
            rol: 1,
            version: 6,
            modeloTarjeta: 1,
          }
        }
            this.setUuid();
            params.uuid = this.pdfet.uuid;
            await this.generarEtiquetas(params);
        },
        async generarEtiquetas(params) {
          this.setType(this.tipo_proceso);
          
          if (this.type === 'et-new') {
            await this.generateNewLabelsScheduling(params).then(async () => {
              this.columns = this.columnsNewEt;
              this.title = 'Etiquetas nuevas';
              await this._loadProccessBackground(this.tipo_proceso);
            });
          } else {
            await this.generateScheduling(params).then(async () => {
              if (this.type === 'et'){
                this.columns = this.columnsEt;
                this.title = 'Etiquetas'
              } else if (this.type === 'te') {
                this.title = 'Tarjetas emergencia';
                this.columns = this.columnsTE;
              }
              await this._loadProccessBackground(this.tipo_proceso);
            });
          }
        },
      async _loadProccessBackground(type) {
        await this.loadProccessBackground({type, company_id: this.selectedEmpresa.id}).then( async () =>{
          await this.$bvModal.show('modal_process_background');
        });

      },
        ...mapMutations('dashboard', ['load']),
        ...mapMutations('background_processes', ['setType']),
        ...mapActions('etiquetas', [
            'agendarEtiquetas',
            'listarEtiquetasAgendadas'
        ]),
        ...mapActions('empresa', ['getDiseno']),
        ...mapMutations('productos', [
            'asignaRol'
        ]),
        ...mapMutations('etiquetas', [
            'setMedidaEtiquetaTexto',
            'setUuid',
            'resetVisualEmpresa',
            'asignarParametrosEtiqueta',
            'setLabelsToDownload',
            'resetDataMeasures',
            'resetDataPdfTE',
            'setNewLabelsConfig',
            'resetNewLabelsConfig'
        ]),
        // Acciones del modulo de Productos diligenciados (rpq)
        ...mapActions('productsSearch', [
          'filterProductsFilledInByName'
        ]),
        /**
         * Controlar cambios en el select de buscar productos.
         *
         * @author Fernando Claros
         */
        async onHandleChangeProducts(value) {

          await this.filterProductsFilledInByName({
            company_id: this.$route.params.id,
            product_param: value
          });

        },
        /**
         * Seleccionar y agregar el producto a la lista.
         *
         * @author Fernando Claros
         */
        onHandleSelectedProductFilled(lists) {
          this.selectedProductFilleds = lists
        },
        /**
         * Eliminar el producto de la lista.
         *
         * @param {Array} lists
         * @author Fernando Claros
         */
        onHandleTrashSelectedProduct(lists) {
          this.selectedProductFilleds = lists
        },
        backRoute(){
            const currentPath = this.$route.path;
            if (currentPath.includes("/my-company")) {
                this.$router.go(-1);
            }else {
                this.$router.push("/empresas");
            }
        },
        /**
         * Manejar el cambio de tipo de etiqueta
         * @author Nelson García
         */
        onChangeType() {
          if (this.type === 'et-new') {
            this.resetNewLabelsConfig();
          }
        },
        /**
         * Obtener el título según el tipo seleccionado
         * @author Nelson García
         */
        getTitleByType() {
          if (this.type === 'et') return 'Etiquetas asignadas';
          if (this.type === 'et-new') return 'Etiquetas nuevas';
          if (this.type === 'te') return 'Tarjetas de emergencia';
          return '';
        },
        /**
         * Validar si el botón de generar debe estar deshabilitado
         * @author Nelson García
         */
        isGenerateButtonDisabled() {
          if (this.type === 'et') {
            return !this.pdfet.tipoEtiqueta;
          }
          if (this.type === 'et-new') {
            return !this.newLabelsConfig.template_id;
          }
          return false;
        },
        /**
         * Obtener el texto del botón de consultar
         * @author Nelson García
         */
        getConsultButtonText() {
          if (this.type === 'et') return 'etiquetas asignadas';
          if (this.type === 'et-new') return 'etiquetas nuevas';
          if (this.type === 'te') return 'tarjetas de emergencia';
          return '';
        },
        /**
         * Manejar cambio de idioma
         * @author Nelson García
         */
        onIdiomaChange(val) {
          if (this.type === 'et-new') {
            this.setNewLabelsConfig({ idioma: val });
          } else {
            this.VisualEmpresa.idioma = val;
          }
        },
        /**
         * Manejar cambio de QR
         * @author Nelson García
         */
        onQrChange(val) {
          if (this.type === 'et-new') {
            this.setNewLabelsConfig({ qr: val });
          } else {
            this.VisualEmpresa.qr = val;
          }
        },
        /**
         * Manejar cambio de ubicación
         * @author Nelson García
         */
        onUbicacionChange(val) {
          if (this.type === 'et-new') {
            this.setNewLabelsConfig({ slq_location_id: val });
          } else {
            this.VisualEmpresa.slq_location_id = val;
          }
        },
        /**
         * Manejar cambio de disponibilidad en inventario
         * @author Nelson García
         */
        onInUseChange(val) {
          if (this.type === 'et-new') {
            this.setNewLabelsConfig({ in_use: val });
          } else {
            this.pdfet.in_use = val;
          }
        },
    },
    computed: {
        ...mapState('empresa', [
            'selectedEmpresa',
            'listadoHistorico',
            'listadoUsuario',
            'listadoDiseno',
            'status',
            'accion',
            'id_creado',
            'conexion',
            'selectedDiseno',
            'formatosEtiquetaEmpresa'
        ]),
        ...mapState('productos', [
            'check_qr',
        ]),
        ...mapState('etiquetas', [
            'idiomas',
            'VisualEmpresa',
            'pdfet',
            'medidaEtiquetaTexto',
            'etiquetasProcesadas',
            'medidas',
            'error',
            'newLabelsTemplates',
            'newLabelsConfig',
            'loadingTemplates'
        ]),
      ...mapState("tareas", ["ubicaciones"]),
      
      isCustomSizePaper() {
        return this.newLabelsConfig.paperSizeDownload === 'Otro';
      },
      
      // Computed properties para v-model
      idiomaModel: {
        get() {
          return this.type === 'et-new' ? this.newLabelsConfig.idioma : this.VisualEmpresa.idioma;
        },
        set(val) {
          if (this.type === 'et-new') {
            this.setNewLabelsConfig({ idioma: val });
          } else {
            this.VisualEmpresa.idioma = val;
          }
        }
      },
      qrModel: {
        get() {
          return this.type === 'et-new' ? this.newLabelsConfig.qr : this.VisualEmpresa.qr;
        },
        set(val) {
          if (this.type === 'et-new') {
            this.setNewLabelsConfig({ qr: val });
          } else {
            this.VisualEmpresa.qr = val;
          }
        }
      },
      ubicacionModel: {
        get() {
          return this.type === 'et-new' ? this.newLabelsConfig.slq_location_id : this.VisualEmpresa.slq_location_id;
        },
        set(val) {
          if (this.type === 'et-new') {
            this.setNewLabelsConfig({ slq_location_id: val });
          } else {
            this.VisualEmpresa.slq_location_id = val;
          }
        }
      },
      inUseModel: {
        get() {
          return this.type === 'et-new' ? this.newLabelsConfig.in_use : this.pdfet.in_use;
        },
        set(val) {
          if (this.type === 'et-new') {
            this.setNewLabelsConfig({ in_use: val });
          } else {
            this.pdfet.in_use = val;
          }
        }
      },
    },
};
</script>
<style>
.selectorTipoEtiqueta {
    margin-top: .1rem;
}

.selectorMultiple {
    margin-bottom: 0px;
}

@media (min-width: 576px) and (max-width: 991px) {
    .modal {
        max-width: 90%;
    }
}

.vue-treeselect__input{
  padding: 9px;
}

.class-border-checkox-only {
  width: 100%;
  border: 1px solid #C0C4CC;
  padding: 5px 10px;
  border-radius: 5px;
}

.sga-option {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.sga-option .option-label {
  display: inline-block;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: calc(100% - 80px); 
}
.sga-option .option-meta {
  color: #8492a6;
  font-size: 13px;
  margin-left: 8px;
  flex: 0 0 auto;
}

.sga-select-dropdown .el-select-dropdown__item:hover {
  background-color: rgba(64,158,255,0.08) !important;
  color: #333 !important;
}
</style>
